// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonBlock_root___Uqrr","left":"ButtonBlock_left__FfcSH","center":"ButtonBlock_center__X3aHJ","right":"ButtonBlock_right__UCxWF"};